// LIBRARIES //
import React from 'react';

// COMPONENTS //
import DrawerFooter from './DrawerFooter';
import { ResidentDetailsTab, ResidentDetailsTabHeader } from './ResidentDetailsTab';

const mobileNavTabFactory = (tabHeaders, tabBodies) => {
  // The TabbedTable uses two arrays of the header and body
  // The new MobileNavContainer takes a tab object
  return tabHeaders.map((header, index) => ({
    value: index,
    label: header,
    component: tabBodies[index],
  }));
};

const NavTabFactory = ({
  residentData,
  disabledProfilePicture,
  closeDrawer,
  reloadPageData,
  toggleChatDrawer,
}) => {
  const tabHeaders = [ResidentDetailsTabHeader];
  const tabBodies = [
    <ResidentDetailsTab
      residentData={residentData}
      disabledProfilePicture={disabledProfilePicture}
      reloadPageData={reloadPageData}
      toggleChatDrawer={toggleChatDrawer}
    />,
  ];

  const tabFooters = Array(tabBodies.length).fill(<DrawerFooter closeDrawer={closeDrawer} />);

  const tabs = mobileNavTabFactory(tabHeaders, tabBodies);

  return { tabHeaders, tabBodies, tabFooters, tabs };
};

export default NavTabFactory;
